import { render, staticRenderFns } from "./DepositGroup.vue?vue&type=template&id=ac74681c&scoped=true&"
import script from "./DepositGroup.vue?vue&type=script&lang=js&"
export * from "./DepositGroup.vue?vue&type=script&lang=js&"
import style0 from "./DepositGroup.vue?vue&type=style&index=0&id=ac74681c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac74681c",
  null
  
)

export default component.exports